var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "webhook-list" } },
    [
      _c(
        "div",
        {
          staticClass: "story story-add",
          on: {
            click: function ($event) {
              _vm.createModal = true
            },
          },
        },
        [
          _c("a-icon", {
            staticStyle: { "font-size": "30px" },
            attrs: { type: "plus-circle", theme: "filled" },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "text-large font-weight-bolder mt-2",
              staticStyle: { "font-size": "20px", "letter-spacing": "2px" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.addWebhook")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.webhooks, function (webhook, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "web-hook-item",
            on: {
              click: function ($event) {
                _vm.updateModal = webhook._id
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "icon-container" },
              [_c("WebhookIcon")],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "text-large font-weight-bolder mt-2 web-hook-title",
                staticStyle: { "font-size": "20px", "letter-spacing": "2px" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(webhook.name.toUpperCase()) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "options" },
              [
                _c(
                  "a-dropdown",
                  {
                    attrs: { trigger: ["click"], placement: "bottomRight" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                [
                                  _c("a-menu-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "icon-container",
                                        on: {
                                          click: function ($event) {
                                            _vm.updateModal = webhook._id
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "md-icon",
                                          {
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                          },
                                          [_vm._v("edit")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("auto.edit"))),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-menu-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "icon-container",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteWebhookModal(
                                              webhook._id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "md-icon",
                                          {
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                          },
                                          [_vm._v("delete")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("chatbotv2.delete"))
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "icon-container ant-dropdown-link",
                        on: {
                          click: function (e) {
                            return e.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("more_horiz"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.createModal
        ? _c("WebHookForm", {
            on: {
              cancel: function ($event) {
                _vm.createModal = false
              },
              confirm: function ($event) {
                _vm.createModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updateModal
        ? _c("WebHookForm", {
            attrs: { id: _vm.updateModal },
            on: {
              cancel: function ($event) {
                _vm.updateModal = null
              },
              confirm: function ($event) {
                _vm.updateModal = null
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }